import React from "react";
import "./pages.css";
import DigitalLoop from "../components/digitalLoop";

function Digital({ handleLogout, deleteItem, user }) {
  return (
    <>
      <section className="mainSection">
        <nav className="hero">
          <h1 className="sr-only">Digital Page</h1>
          <button onClick={handleLogout}>Log Out</button>
        </nav>

        <main className="grundge1">
          <DigitalLoop deleteItem={deleteItem} user={user} />
        </main>
      </section>
    </>
  );
}

export default Digital;
